<template>
    <div class="question" :class="{'new':newClass}">
        <h2 class="title" v-html="questionLabel"></h2>
        <p v-if="question.text !== ''" v-html="questionText"></p>
        <div v-if="question.type !== 'none'">
            <div v-if="question.type === 'text'">
                <input type="text" v-model="value" :readonly="locked" placeholder="Réponse" @focus="$emit('textfocus')" @blur="$emit('textblur'); updateValue()" @keypress.enter="updateValue()">
            </div>
            <div v-if="question.type === 'textarea'">
                <textarea type="text" v-model="value" :readonly="locked" placeholder="Réponse" @focus="$emit('textfocus')" @blur="$emit('textblur'); updateValue()" @keypress.enter="updateValue()"></textarea>
            </div>
            <div v-if="question.type === 'select' && !isPrint" class="select">
<!--                <select v-model="value" :disabled="locked">-->
<!--                    <option v-for="(content,k) in question.content" :value="content.value">{{content.value}}</option>-->
<!--                </select>-->
                <model-list-select v-model="value"
                                   :list="questionContentList"
                                   option-value="value"
                                   option-text="value"
                                   :isDisabled="locked"
                                   placeholder="Sélectionner une réponse">
                </model-list-select>
            </div>
            <div v-if="question.type === 'select' && isPrint" class="select-print">
                <i>Sélectionner une réponse</i>
                <ul>
                    <li v-for="q in questionContentList" v-if="q !== ''">{{q.value}}</li>
                </ul>
            </div>
            <div v-if="question.type === 'checkbox'" class="checkbox-content">
                <div v-for="(content,k) in question.content" class="checkbox mb">
                    <label>
                        <input type="checkbox" :checked="isChecked(k)" :disabled="locked" @change="onChange(k,$event)">
                        {{content.value}}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import tools from '../../config.ts';
    import {ModelListSelect} from 'vue-search-select';

    export default {
        name: "Question",
        components: {ModelListSelect},
        props: {
            question: {},
            response: {},
            locked: false,
            k: 0,
            newClass:false,
            isPrint:false,
        },
        data() {
            return {
                value: "",
                checkbox:[],
            }
        },
        methods: {
            isCheckbox() {
                return this.question.type === 'checkbox' || this.question.type === 'radio' || this.question.type === 'select';
            },
            onChange(k,$event){

                this.checkbox[k] = $event.target.checked ? this.question.content[k].value : "";

                // console.log(this.checkbox);
                tools.$emit("newResponse", this.k, {
                    question: this.question.id,
                    value: this.checkbox
                })
            },
            isChecked(k){
                return this.checkbox[k];
            },
            valueText(content){
                return content.value;
            },
            updateValue(){
                let value = this.value;
                if(!Array.isArray(value)){
                    value = [value]
                }

                tools.$emit("newResponse", this.k, {
                    question: this.question.id,
                    value: [this.value]
                })
                // console.log(value)
            }
        },
        computed:{
            questionLabel(){
                return tools.nl2br(this.question.label)
            },
            questionText(){
                if(!this.question.text){
                    return ""
                }
                return tools.nl2br(this.question.text)
            },
            questionContentList(){
                return [""].concat(this.question.content);
            }
        },
        watch: {
            value() {
                if(this.question.type === 'text' || this.question.type === 'textarea'){
                    return;
                }

                let value = this.value;
                if(!Array.isArray(value)){
                    value = [value]
                }

                tools.$emit("newResponse", this.k, {
                    question: this.question.id,
                    value: [this.value]
                })
                // console.log(value)

            },
            // response(){
            //     console.log("update response");
            //     console.log(this.response)
            //     this.value = this.response.value[0]
            // }
        },
        mounted() {
            // console.log(this.question)
            // console.log(this.response)
            if(this.response && this.response.value && this.response.value.length > 0){
                this.value = this.response.value[0]
            }
            if(this.question.content.length > 1 && this.question.type === "checkbox"){
                this.question.content.forEach((content) => {
                    this.checkbox.push("")
                })

                if(this.response.value){
                    this.response.value.forEach((rep,k) => {
                        this.checkbox[k] = rep
                    })
                }
            }
        }
    }
</script>

<style>

</style>
